import { graphql } from '@/graphql/generated/seller';

export const inventoriesQuery = graphql(`
  query InventoriesQuery(
    $limit: Int!
    $offset: Int!
    $where: InventoriesBoolExp!
    $orderBy: [InventoriesOrderByExp!]!
  ) {
    inventories(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      skuId
      skuName
      skuDescription
      locationId
      locationName
      status
      qtyExpected
      qtyOnHand
      qtyReserved
      qtyAvailable
      sku {
        archivedAt
      }
    }
    inventoriesAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
